(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Auth0Analytics"] = factory();
	else
		root["Auth0Analytics"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadScript;

var _logger = __webpack_require__(1);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function loadScript(_ref, callback) {
  var src = _ref.src,
      id = _ref.id,
      globalName = _ref.globalName,
      globalNames = _ref.globalNames,
      stubType = _ref.stubType,
      stubMethods = _ref.stubMethods,
      _ref$stub = _ref.stub,
      stub = _ref$stub === undefined ? null : _ref$stub,
      window = _ref.window,
      document = _ref.document;

  var script = document.createElement('script');
  var first = document.getElementsByTagName('script')[0];
  var internalStub = stub || createStub(stubType, stubMethods);

  if (internalStub) {
    if (globalName) window[globalName] = internalStub;
    (globalNames || []).forEach(function (name) {
      window[name] = internalStub;
    });
  }

  script.async = true;
  script.src = src;
  script.type = 'text/javascript';
  if (id) {
    script.id = id;
  }

  var promise = new Promise(function (resolve, reject) {
    script.onerror = function () {
      var error = 'Error loading ' + src;

      _logger2.default.debug(error);
      if (internalStub && internalStub._onError) {
        internalStub._onError(error);
      }

      if (callback) {
        callback(error);
      }

      reject(error);
    };

    script.onload = function () {
      _logger2.default.debug(src + ' loaded successfully');
      if (internalStub && internalStub._onLoad) {
        internalStub._onLoad(window[globalName || globalNames[0]]);
      }

      if (callback) {
        callback(null, window[globalName || globalNames[0]]);
      }

      resolve(window[globalName || globalNames[0]]);
    };
  });

  first.parentNode.insertBefore(script, first);

  return promise;
}

function createStub(stubType, stubMethods) {
  if (stubType === 'function') {
    return createFunctionStub(stubMethods);
  }

  return null;
}

function createFunctionStub(stubMethods) {
  var enqueueCall = function enqueueCall(target, method, args) {
    target._queue = target._queue || [];
    target._queue.push({ method: method, args: args });
    return target;
  };

  var stub = function stub() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return enqueueCall(stub, null, args);
  };

  (stubMethods || []).forEach(function (method) {
    stub[method] = function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return enqueueCall(stub, method, args);
    };
  });

  stub._onLoad = function (library) {
    while ((stub._queue || []).length) {
      var call = stub._queue.shift();
      call.method ? library[call.method].apply(library, _toConsumableArray(call.args)) : library.apply(undefined, _toConsumableArray(call.args));
    }
  };

  return stub;
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  log: function log() {},
  debug: function debug() {},
  error: function error() {}
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialize = initialize;

var _logger = __webpack_require__(1);

var _logger2 = _interopRequireDefault(_logger);

var _facebookPixel = __webpack_require__(5);

var _facebookPixel2 = _interopRequireDefault(_facebookPixel);

var _facebookAnalytics = __webpack_require__(4);

var _facebookAnalytics2 = _interopRequireDefault(_facebookAnalytics);

var _googleAnalytics = __webpack_require__(7);

var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);

var _twitterAdsPixel = __webpack_require__(8);

var _twitterAdsPixel2 = _interopRequireDefault(_twitterAdsPixel);

var _googleAdwords = __webpack_require__(6);

var _googleAdwords2 = _interopRequireDefault(_googleAdwords);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initialize(config, callback) {
  if (!config) {
    return handleError(new Error('config is required.'), callback);
  }
  if (!config.label) {
    return handleError(new Error('config.label is required.'), callback);
  }

  var promises = [];
  var handlers = [];
  var tagManager = {
    page: function page() {
      handlers.forEach(function (handler) {
        try {
          handler({ type: 'page', label: config.label });
        } catch (error) {
          _logger2.default.error('Error on page() handler');
          _logger2.default.error(error);
        }
      });
    },
    track: function track(id) {
      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      handlers.forEach(function (handler) {
        try {
          handler({ type: 'track', id: id, properties: properties, label: config.label });
        } catch (error) {
          _logger2.default.error('Error on page() handler');
          _logger2.default.error(error);
        }
      });
    },
    setUserId: function setUserId(userId) {
      handlers.forEach(function (handler) {
        try {
          handler({ type: 'setUserId', userId: userId });
        } catch (error) {
          _logger2.default.error('Error on setUserId() handler');
          _logger2.default.error(error);
        }
      });
    }
  };

  if (config['facebook-pixel']) {
    promises.push((0, _facebookPixel2.default)({ config: config['facebook-pixel'], handlers: handlers, window: window, document: document }));
  }

  if (config['facebook-analytics']) {
    promises.push((0, _facebookAnalytics2.default)({ config: config['facebook-analytics'], handlers: handlers, window: window, document: document }));
  }

  if (config['google-analytics']) {
    promises.push((0, _googleAnalytics2.default)({ config: config['google-analytics'], handlers: handlers, window: window, document: document }));
  }
  if (config['twitter-ads-pixel']) {
    promises.push((0, _twitterAdsPixel2.default)({ config: config['twitter-ads-pixel'], handlers: handlers, window: window, document: document }));
  }

  if (config['google-adwords']) {
    promises.push((0, _googleAdwords2.default)({ config: config['google-adwords'], handlers: handlers, window: window, document: document }));
  }

  Promise.all(promises).then(function () {
    if (callback) callback(null, tagManager);
    return tagManager;
  }).catch(function (error) {
    return handleError(error, callback);
  });

  return tagManager;
}

function handleError(error, callback) {
  if (callback) {
    return callback(error);
  }
  return Promise.reject(error);
}

exports.default = initialize;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Deferred = function () {
  function Deferred() {
    _classCallCheck(this, Deferred);

    this.isReady = false;
    this.queue = [];
  }

  _createClass(Deferred, [{
    key: "_ready",
    value: function _ready() {
      this.isReady = true;
      var value = this.queue.shift();
      while (value) {
        value();
        value = this.queue.shift();
      }
    }
  }, {
    key: "push",
    value: function push(fn) {
      if (this.isReady) {
        fn();
      } else {
        this.queue.push(fn);
      }
    }
  }, {
    key: "run",
    value: function run(isReady) {
      var _this = this;

      if (isReady()) {
        this._ready();
      } else {
        this.timeout = setTimeout(function () {
          _this.run(isReady);
        }, 100);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }]);

  return Deferred;
}();

exports.default = Deferred;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global FB */


exports.default = configureFacebookAnalitycs;

var _scriptLoader = __webpack_require__(0);

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

var _defered = __webpack_require__(3);

var _defered2 = _interopRequireDefault(_defered);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureFacebookAnalitycs(_ref) {
  var config = _ref.config,
      handlers = _ref.handlers,
      window = _ref.window,
      document = _ref.document;

  var promise = Promise.resolve();

  if (!config.preloaded) {
    var src = 'https://connect.facebook.net/en_US/sdk.js';
    window.fbAsyncInit = function () {
      FB.init({
        appId: config.id,
        xfbml: true,
        version: 'v2.8'
      });
    };

    promise = (0, _scriptLoader2.default)({ src: src, id: 'facebook-jssdk', globalName: 'FB', window: window, document: document });
  }

  var deferred = new _defered2.default();
  deferred.run(function () {
    return (typeof FB === 'undefined' ? 'undefined' : _typeof(FB)) === 'object' && window.fbAsyncInit.hasRun;
  });

  handlers.push(handleEvent);

  return promise;

  function handleEvent(_ref2) {
    var type = _ref2.type,
        id = _ref2.id,
        properties = _ref2.properties,
        userId = _ref2.userId;

    if (type === 'page') {
      return deferred.push(function () {
        FB.AppEvents.logPageView();
      });
    }

    if (type === 'track') {
      return deferred.push(function () {
        FB.AppEvents.logEvent(id, null, properties);
      });
    }

    if (type === 'setUserId' && userId) {
      return deferred.push(function () {
        FB.AppEvents.setUserID(userId);
      });
    }

    return null;
  }
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureFacebookPixel;

var _scriptLoader = __webpack_require__(0);

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureFacebookPixel(_ref) {
  var config = _ref.config,
      handlers = _ref.handlers,
      window = _ref.window,
      document = _ref.document;

  var promise = Promise.resolve();

  if (!config.preloaded) {
    var src = 'https://connect.facebook.net/en_US/fbevents.js';
    var stub = function stub() {
      stub.callMethod ? stub.callMethod.apply(stub, arguments) : stub.queue.push(arguments);
    };
    stub.push = stub;
    stub.loaded = !0;
    stub.version = '2.0';
    stub.queue = [];

    promise = (0, _scriptLoader2.default)({ src: src, globalNames: ['fbq', '_fbq'], stub: stub, window: window, document: document });

    window.fbq('init', config.id);
  }

  handlers.push(handleEvent);

  return promise;
}

function handleEvent(_ref2) {
  var type = _ref2.type,
      id = _ref2.id,
      properties = _ref2.properties;

  if (type === 'page') {
    return window.fbq('track', 'PageView');
  }

  if (type === 'track') {
    return window.fbq('trackCustom', id, properties);
  }

  // TODO: Facebook Pixel does not yet support Setting the
  // UserId like Facebook SDK does.

  return null;
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureGoogleAdWords;

var _scriptLoader = __webpack_require__(0);

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureGoogleAdWords(_ref) {
  var config = _ref.config,
      handlers = _ref.handlers,
      window = _ref.window,
      document = _ref.document;

  var promise = Promise.resolve();

  if (config.preloaded) {
    var src = 'https://www.googleadservices.com/pagead/conversion_async.js';
    promise = (0, _scriptLoader2.default)({ src: src, globalName: 'google_trackConversion', stubType: 'function', window: window, document: document });
  }

  handlers.push(handleEvent.bind(null, config.id, config.mappings));

  return promise;
}

function handleEvent(conversionId, mappings, _ref2) {
  var type = _ref2.type,
      id = _ref2.id;

  if (type === 'track') {
    return (mappings || []).filter(function (mapping) {
      return mapping.evt === id;
    }).forEach(function (mapping) {
      window.google_trackConversion({
        google_conversion_id: conversionId,
        google_conversion_label: mapping.label,
        google_remarketing_only: false
      });
    });
  }

  return null;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureGoogleAnalitycs;

var _scriptLoader = __webpack_require__(0);

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureGoogleAnalitycs(_ref) {
  var config = _ref.config,
      handlers = _ref.handlers,
      window = _ref.window,
      document = _ref.document;

  var promise = Promise.resolve();

  if (config.preloaded) {
    var src = 'https://www.google-analytics.com/analytics.js';
    var stub = function stub() {
      stub.q.push(arguments);
    };
    stub.q = [];
    stub.l = 1 * new Date();
    window.GoogleAnalyticsObject = 'ga';

    promise = (0, _scriptLoader2.default)({ src: src, globalName: 'ga', stub: stub, window: window, document: document });
    window.ga('create', config.id, 'auto');
  }

  handlers.push(handleEvent);

  return promise;

  function handleEvent(_ref2) {
    var type = _ref2.type,
        eventAction = _ref2.id,
        properties = _ref2.properties,
        label = _ref2.label,
        userId = _ref2.userId;

    var location = window.location || {};
    if (type === 'page') {
      return window.ga('send', 'pageview', {
        page: '' + location.pathname + location.search + location.hash
      });
    }

    if (type === 'track') {
      var gaEvent = {
        hitType: 'event',
        eventCategory: properties.category || 'All',
        eventAction: eventAction,
        eventLabel: properties.label || label
      };
      return window.ga('send', gaEvent);
    }

    if (type === 'setUserId' && userId) {
      return window.ga('set', 'userId', userId);
    }

    return null;
  }
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureTwitterAdsPixel;

var _scriptLoader = __webpack_require__(0);

var _scriptLoader2 = _interopRequireDefault(_scriptLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureTwitterAdsPixel(_ref) {
  var config = _ref.config,
      handlers = _ref.handlers,
      window = _ref.window,
      document = _ref.document;

  var promise = Promise.resolve();

  if (config.preloaded) {
    var src = 'https://static.ads-twitter.com/uwt.js';
    var stub = function stub() {
      stub.exe ? stub.exe.apply(stub, arguments) : stub.queue.push(arguments);
    };

    stub.version = '1.1';
    stub.queue = [];

    promise = (0, _scriptLoader2.default)({ src: src, globalName: 'twq', stub: stub, window: window, document: document });
    window.twq('init', config.id);
  }

  handlers.push(handleEvent.bind(null, config.mappings));

  return promise;
}

function handleEvent(mappings, _ref2) {
  var type = _ref2.type,
      id = _ref2.id,
      properties = _ref2.properties;

  if (type === 'page') {
    return window.twq('track', 'PageView');
  }

  if (type === 'track') {
    return (mappings || []).filter(function (mapping) {
      return mapping.evt === id;
    }).forEach(function (mapping) {
      return window.twttr.conversion.trackPid(mapping.pid, properties);
    });
  }

  return null;
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _auth0TagManager = __webpack_require__(2);

var _auth0TagManager2 = _interopRequireDefault(_auth0TagManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analytics = void 0; /* global window, Auth0Lock */


var IGNORED_EVENTS = ['hash_parsed'];

function eventShouldBeIgnored(name) {
  if (typeof name !== 'string') throw new Error('Lock event name must be string.');

  return IGNORED_EVENTS.indexOf(name) !== -1;
}

function eventIsAvailable(lock, name) {
  if (typeof name !== 'string') throw new Error('Lock event name must be string.');

  return lock.validEvents.indexOf(name) !== -1;
}

function setupEvent(lock, name) {
  var tracker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : analytics;

  if (!eventIsAvailable(lock, name)) return;

  lock.on(name, function (payload) {
    if (name === 'authenticated' && payload && payload.idTokenPayload && payload.idTokenPayload.sub) {
      tracker.setUserId(payload.idTokenPayload.sub);
    }
    var eventName = 'auth0 lock ' + name;
    tracker.track(eventName);
  });
}

function init(lock) {
  if (!window.auth0AnalyticsOptions) {
    throw new Error('You must provide initialization options for Auth0 Analytics.');
  }

  if (!window.auth0AnalyticsOptions.label) {
    window.auth0AnalyticsOptions.label = 'Auth0 Analytics';
  }

  analytics = (0, _auth0TagManager2.default)(window.auth0AnalyticsOptions);

  lock.validEvents.forEach(function (name) {
    if (eventShouldBeIgnored(name)) return; // Not needed for analytics
    setupEvent(lock, name);
  });
}

if (typeof Auth0Lock === 'function') {
  var prototype = Auth0Lock.prototype;
  Auth0Lock = function Auth0Lock() {
    var lock = prototype.constructor.apply(this, arguments);
    init(lock);
    return lock;
  };

  Auth0Lock.prototype = prototype;
}

module.exports = {
  IGNORED_EVENTS: IGNORED_EVENTS,
  eventShouldBeIgnored: eventShouldBeIgnored,
  eventIsAvailable: eventIsAvailable,
  setupEvent: setupEvent,
  init: init
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// analytics.min.js